import CorpJoinCreateDialog from './CorpJoinCreateDialog';
import './style/index.less';

export default CorpJoinCreateDialog;
